import plotComponentFactory from './factory';
import Plotly from 'plotly.js/dist/plotly';

const PlotComponent = plotComponentFactory(Plotly);

export default PlotComponent;
